"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isSinglePrice(canNegotiateNew, canNegotiateUsed, vehicleCondition) {
    return vehicleCondition.toLowerCase() === 'new' ? !canNegotiateNew : !canNegotiateUsed;
}
exports.isSinglePrice = isSinglePrice;
